import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { shipmentsAPI } from "../../api/shipments/shipments";

const initialState = {
    shipmentBills: [],
    unauthorized: false,
    unpaidBillsCount: 0,
    statuses: {
        upload: null,
    },
    errors: {
        upload: null,
    }
};

export const uploadShipmentBills = createAsyncThunk(
    'shipmentBills/uploadShipmentBills',
    async (shipmentBills, {rejectWithValue}) => {
        const res = await shipmentsAPI.uploadShipmentBills();
        if(res.unauthorized) {
            return rejectWithValue({err: "unauthorized"})
        }
        if(res.ok) {
            return res.shipmentBills
        }
        if(res.err) {
            return rejectWithValue({err: res.err})
        }
        return rejectWithValue({err: "something_went_wrong"})
    }
);
export const getLinkToPaySession = createAsyncThunk(
    'shipmentBills/getLinkToPaySession',
    async (shipmentBillId, {rejectWithValue}) => {
        const res = await shipmentsAPI.getLinkToPaySession(shipmentBillId);
        if(res.unauthorized) {
            return rejectWithValue({err: "unauthorized"})
        }
        if(res.ok) {
            return res.link
        }
        if(res.err) {
            return rejectWithValue({err: res.err})
        }
        return rejectWithValue({err: "something_went_wrong"})
    }
);
const shipmentBillsSlice = createSlice({
    name: 'shipmentBills',
    initialState,
    reducers: {
        setUnauthorized(state, action) {
            if(!action.payload) {
                state.unauthorized = false;
                return;
            }
            state.unauthorized = action.payload
        }
    },
    extraReducers(builder) {
        builder
            .addCase(uploadShipmentBills.pending, (state, action) => {
                state.statuses.upload = "pending"
                state.errors.upload = null
            })
            .addCase(uploadShipmentBills.fulfilled, (state, action) => {
                state.statuses.upload = "fulfilled"
                state.errors.upload = null
                state.shipmentBills = action.payload ?? []
                
                let unpaidCount = state.shipmentBills.reduce((acc, bill) => {
                    if(!bill.paid) {
                        return acc + 1
                    }
                    return acc
                }, 0)

                if(unpaidCount >= 0) {
                    state.unpaidBillsCount = unpaidCount
                }
            })
            .addCase(uploadShipmentBills.rejected, (state, action) => {
                state.statuses.upload = "rejected"
                let err = action.payload.err;
                if(err === "unauthorized") {
                    state.unauthorized = true
                    state.errors.upload = null
                    state.shipmentBills = []
                return
                }
                state.errors.upload = action.payload.err ?? "something_went_wrong"
                state.shipmentBills = []
            })     
    }
});

export const {setUnauthorized} = shipmentBillsSlice.actions

export const selectShipmentBills = state => state.shipmentBills.shipmentBills;
export const selectUnpaidBillsCount = state => state.shipmentBills.unpaidBillsCount;
export const selectShipmentBillsUploadStatus = state => state.shipmentBills.statuses.upload;
export const selectShipmentBillsUploadErrors = state => state.shipmentBills.errors.upload;

export default shipmentBillsSlice.reducer;